import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { ContextState } from '@new/common/state/context';
import { isVoid } from '@new/common/utils/type-guards/voidable';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private store: Store) {}

  public canActivate(): boolean {
    const user = this.store.selectSnapshot(ContextState.currentUser);
    if (isVoid(user)) return false;

    return user.superUser;
  }
}
